import React from 'react';
import { useSelector } from 'react-redux';

import { Flex, Input, Select, Typography } from 'antd';
import FileUpload from '../../../../../../components/FileUpload';

const { Text } = Typography;

export const TableCol = (action, status) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const { research_roles: researchRoles } = staticData;

  return [
    {
      key: 'role',
      dataIndex: 'role',
      title: 'Role',
      render: (value, row) => {
        const _roles = researchRoles.filter((item) => item.id === value);
        const _role = _roles[0];

        return (
          <Select
            style={{ width: '300px', minHeight: '64px' }}
            options={[
              ...researchRoles.map((event) => ({
                value: event.id,
                label: (
                  <Flex vertical>
                    <Text>{event?.name}</Text>
                    <Text type="secondary">({event?.point} APA Points)</Text>
                  </Flex>
                )
              }))
            ]}
            defaultValue={_role.id}
            placeholder="Select a Event"
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) => action({ ...row, role: e })}
          />
        );
      }
    },
    {
      key: 'detail',
      dataIndex: 'detail',
      title: 'Details',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, detail: e.target.value })}
        />
      )
    },
    {
      key: 'upload',
      dataIndex: 'attachment',
      title: 'Attachments',
      render: (fileList, row) => (
        <FileUpload
          fileList={fileList}
          row={row}
          action={action}
          disabled={status === 1 || status === 2 || status === 3}
          status={status}
          isMandatory={true}
        />
      )
    },
    {
      key: 'apa_point',
      dataIndex: 'apa_point',
      title: 'APA Point'
    }
  ];
};
